import styled from 'styled-components'

export const LoaderDiv = styled.div`    
    display: flex;
    justify-content:center;
    flex-direction: column;
    align-items: center;
    // height: 50vh;
`